// App-specific config

// Using CommonJS instead of ES2015+ export, because we also need to
// provide this object to Webpack in vue.config.js.
module.exports = {
  title: 'Power Waste Management WebApp',
  description: 'A backend interface, administration and client portal for the Power Waste management system.',
}
